import React from 'react'
const Logo = require('../images/awaiver-logo.svg');

const MainLogo = ({ waiver }) => (
    <div className="main-logo">
        {waiver.waiverId > 0 && waiver.companyLogoUrl !== null ? (
            <img src={waiver.companyLogoUrl} alt="Company Logo" />
        ) : (
                <img src={Logo} alt="AWaiver" />
            )}
    </div>
)

export default MainLogo
